<script>
  import { onMount } from 'svelte';
  import { currentUser } from './utils';
  import { getStatus, getGridList } from './api';
  export let user = null;
  let mounted = false;
  let appStatus, gridList;

  const gridStatus = async (id) => {
    let status = await getStatus($currentUser.fullClientId, $currentUser.accessToken, id);
    return status.live;
  };

  onMount(async () => {
    if (user) {
      $currentUser = user;
      appStatus = await getStatus($currentUser.fullClientId, $currentUser.accessToken);
      appStatus = appStatus.live;
      gridList = await getGridList($currentUser.fullClientId, $currentUser.accessToken);
      mounted = true;
    }
  });
</script>

{#if mounted}
  <main>
    <h1>Go Live</h1>
    <div class="table sb-scrollbar sb-scrollbar-horizontal">
      <table>
        <thead>
          <tr>
            <th scope="col">Grid Name</th>
            <th scope="col">Status</th>
            <th scope="col" />
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Shopbox App</td>
            {#if appStatus == true}
              <td class="status active">Active</td>
              <td />
            {:else}
              <td class="status">Inactive</td>
              <td><a href="/">Request help</a></td>
            {/if}
          </tr>
          {#if Array.isArray(gridList)}
            {#each gridList as grid}
              {#if grid.name}
                <tr>
                  <td>{grid.name}</td>
                  {#await gridStatus(grid.id)}
                    <td>Loading..</td>
                    <td />
                  {:then value}
                    {#if value}
                      <td class="status active">Active</td>
                      <td />
                    {:else}
                      <td class="status">Inactive</td>
                      <td><a href="/">Request help</a></td>
                    {/if}
                  {:catch error}
                    <td />
                  {/await}
                </tr>
              {/if}
            {/each}
          {/if}
        </tbody>
      </table>
    </div>
  </main>
{/if}

<style>:global(*){box-sizing:border-box;margin:0}:global(html,body){font-family:Overpass,sans-serif;height:100%;width:100%}h1{font-family:Chivo,serif;margin-bottom:1.5em}main{margin:0 auto;position:relative;width:100%}.table{border:1px solid var(--brd-l);border-radius:4px;color:var(--t-c);overflow-y:scroll;padding:1em 0 1em 1em;width:100%}.table :global(table){border-collapse:collapse;width:100%}thead{border-bottom:2px solid var(--brd-l);color:var(--t-c-lx);text-align:left}th{font-weight:400;margin-bottom:1em}tr{border-bottom:1px solid #ddd}td,th{width:25%}td:first-of-type,th:first-of-type{width:40%}a{color:var(--l-c);font-size:.9em;text-decoration:underline!important}.table td{font-size:1rem;padding:11px 0;text-align:left}td.status{padding-left:20px;position:relative}.status:before{border:1px solid #000;border-radius:50%;content:"";height:7px;left:0;position:absolute;top:17px;width:7px}.status.active:before{background-color:#2dc307;border:1px solid #2dc307}.table tr:last-of-type{border-bottom:none}.table tr>td:last-child{text-align:right;white-space:nowrap}@media (max-width:600px){table{overflow-x:scroll}}</style>
